import {Exclude, Expose, instanceToPlain, plainToInstance, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {SiteArrayValidator, SiteEntity} from "./site";
import {Default} from "../util/decorators";

export const GeofenceSiteGroupCodec = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    regionId: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    sites: SiteArrayValidator,
  }),
]);

export const GeofenceSiteGroupArrayCodec = t.array(
  GeofenceSiteGroupCodec
);

export type GeofenceSiteGroup = t.TypeOf<typeof GeofenceSiteGroupCodec>;
export type GeofenceSiteGroupArray = t.TypeOf<typeof GeofenceSiteGroupArrayCodec>;

@Exclude()
export class GeofenceSiteGroupEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  regionId?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  @Expose()
  @Type(() => SiteEntity)
  @Default([])
  sites: SiteEntity[] = [];

  readonly entityType = 'GEOSITEGROUP';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for GeofenceSiteGroupEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: GeofenceSiteGroup): GeofenceSiteGroupEntity {
    return plainToInstance(GeofenceSiteGroupEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<GeofenceSiteGroup> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(GeofenceSiteGroupCodec, object);
  }

  asTypeValue(): GeofenceSiteGroup {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(GeofenceSiteGroupCodec, object);
  }
}
